/**
 * The github kind of team connection as the staff pages read it
 * (TRA-1108): one per team, resolved from the team's connection list.
 * Kept apart from the components so the Connections page and its GitHub
 * section share it without exporting a non-component from a component
 * file.
 */

import type { ConnectionAdminItem } from '@/api/generated/model'

/** Where cloud GitHub's REST API lives; the api's default for a github row. */
export const GITHUB_CLOUD_API_BASE_URL = 'https://api.github.com'

export function githubConnectionOf(
  connections: ConnectionAdminItem[],
): ConnectionAdminItem | undefined {
  return connections.find((row) => row.kind === 'github')
}
